import { render, staticRenderFns } from "./NewBatchDialog.vue?vue&type=template&id=6b7d38c4&scoped=true"
import script from "./NewBatchDialog.vue?vue&type=script&lang=js"
export * from "./NewBatchDialog.vue?vue&type=script&lang=js"
import style0 from "./NewBatchDialog.vue?vue&type=style&index=0&id=6b7d38c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d38c4",
  null
  
)

export default component.exports